import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "./Home.vue?vue&type=style&index=0&id=6229083d&lang=scss&scoped=true"

import exportComponent from "D:\\a-mydemo\\houlang\\gs-demo\\keymemo-demo\\keymemory-pc-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6229083d"]])

export default __exports__